export enum AppVariant {
  GbSidedoor = 'gb/sidedoor',
  GbSidedoorAmdea = 'gb/sidedoor-amdea',
  GbSidedoorSda = 'gb/sidedoor-sda',
  GbSidedoorPromo = 'gb/sidedoor-promo',
  IeSidedoor = 'ie/sidedoor',
}
